"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowedSearchSyncUpdateTypes = exports.TimestampOperators = exports.StringOperators = exports.OperatorByFieldType = exports.NumberOperators = exports.FieldTypes = exports.DateOperators = void 0;
var schema_1 = require("./schema");
Object.defineProperty(exports, "DateOperators", { enumerable: true, get: function () { return schema_1.DateOperators; } });
Object.defineProperty(exports, "FieldTypes", { enumerable: true, get: function () { return schema_1.FieldTypes; } });
Object.defineProperty(exports, "NumberOperators", { enumerable: true, get: function () { return schema_1.NumberOperators; } });
Object.defineProperty(exports, "OperatorByFieldType", { enumerable: true, get: function () { return schema_1.OperatorByFieldType; } });
Object.defineProperty(exports, "StringOperators", { enumerable: true, get: function () { return schema_1.StringOperators; } });
Object.defineProperty(exports, "TimestampOperators", { enumerable: true, get: function () { return schema_1.TimestampOperators; } });
exports.AllowedSearchSyncUpdateTypes = [
    'sourgum-order',
    'wayste-order',
    'sourgum-receivable',
    'sourgum-payable',
    'wayste-receivable',
    'wayste-payable',
    'sourgum-customer',
    'wayste-customer',
    'sourgum-vendor',
    // 'WaysteVendor',
    'sourgum-pricing-zone',
    'sourgum-service-grouping',
    // 'sourgum-hauler-pricing-zone', unified with sourgum-pricing-zone into one index
    'wayste-pricing-zone',
    'sourgum-lead',
    'wayste-disposal-site',
    'wayste-dumpster',
    'audit-log',
    'wayste-commercial-subscription',
    'wayste-tagged-container',
    'operations-subscription',
];
//# sourceMappingURL=index.js.map